import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { Apply2Response } from "../../api/types/apply2"

type initialState = {
    response: Apply2Response | null
}

const apply2Slice = createSlice({
    name: "apply2",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.apply2.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default apply2Slice.reducer




